<!--
<p-select [options]="adminAnnotations" [(ngModel)]="selectedAnnotation" optionLabel="annotation" [filter]="false" (onChange)="selected($event)" filterBy="annotation" [showClear]="false" placeholder="Common annotations">
  <ng-template pTemplate="selectedItem">
    @if (selectedAnnotation) {
      <div>
        <div><i class="mdi mdi-checkbox-blank-circle" class="{{ selectedAnnotation.rag }}"></i> {{ selectedAnnotation.text }}</div>
      </div>
    }
  </ng-template>
  <ng-template let-annotation pTemplate="item">
    <div>
      <div>
        <i class="mdi mdi-checkbox-blank-circle" class="{{ annotation.rag }}"></i>
        {{ annotation.text }}
      </div>
    </div>
  </ng-template>
</p-select>
-->
@if (list()) {
  <app-select-dialog size="small" label="Common annotations" [value]="selectedAnnotation" [list]="list()" (onSelected)="selectedDialog($event)" [dimensions]="{ width: 500, height: 500 }" [heading]="'Annotation'" />
}
